import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import lockIcon from "../../icons/lock.svg";
import homeIcon from "../../icons/home.svg";
import personGroupIcon from "../../icons/person-group.svg";
import truckIcon from "../../icons/truck.svg";
import latestCalendarIcon from "../../icons/latest-calendar.svg";
import listUlIcon from "../../icons/list-ul.svg";
import TransfersIcon from "../../icons/transfers.svg";
import infoShieldIcon from "../../icons/info-shield.svg";
import reportIcon from "../../icons/report.svg";
import bellIcon from "../../icons/bell.svg";
import discountIcon from "../../icons/discount.svg";
import ticketIcon from "../../icons/ticket.svg";
import talkIcon from "../../icons/talks.svg";
import arrowRightSquareIcon from "../../icons/arrow-right-square.svg";
import supportIcon from "../../icons/support.svg";

const Tooltip = ({ label, targetRef, visible }) => {
  const [style, setStyle] = useState({});

  useEffect(() => {
    if (visible && targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      setStyle({
        top: rect.top + rect.height / 2,
        left: rect.right +1,
      });
    }
  }, [visible, targetRef]);

  if (!visible || !label) return null;

  return (
    <div className="sidebar-tooltip" style={style}>
      <div className="sidebar-tooltip__arrow" />
      <span>{label}</span>
    </div>
  );
};

const NavItem = ({ to, label, icon, match, isCollapsed, exact }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const ref = useRef(null);
  const { pathname } = useLocation();

  const isMatchActive = exact ? pathname === match : pathname.startsWith(match);

  return (
    <li
      ref={ref}
      onMouseEnter={() => isCollapsed && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <NavLink
        to={to}
        end={exact}
        className={({ isActive }) =>
          isActive || isMatchActive
            ? "sidebar-link active"
            : "sidebar-link"
        }
        activeclassname="active"
      >
        <img
          className={isMatchActive ? "img_invert" : ""}
          src={icon}
          alt={label}
        />
        {!isCollapsed && <span>{label}</span>}
      </NavLink>
      <Tooltip label={label} targetRef={ref} visible={showTooltip} />
    </li>
  );
};

const Navigation = ({ userDetails }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showLogoutTooltip, setShowLogoutTooltip] = useState(false);
  const logoutRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    const baseLayout = document.querySelector(".l-base-layout");
    if (baseLayout) {
      if (isCollapsed) {
        baseLayout.classList.add("sidebar-collapsed");
      } else {
        baseLayout.classList.remove("sidebar-collapsed");
      }
    }
  }, [isCollapsed]);

  const navItems = [
    { to: "/", label: "Home", icon: homeIcon, match: "/", exact: true },
    { to: "/clients", label: "Clients", icon: personGroupIcon, match: "/client" },
    { to: "/mavs", label: "MAVs", icon: truckIcon, match: "/mav" },
    { to: "/jobs", label: "Jobs", icon: latestCalendarIcon, match: "/job" },
    { to: "/quotes", label: "Quotes", icon: listUlIcon, match: "/quote" },
    { to: "/conversations", label: "Conversations", icon: talkIcon, match: "/conversations" },
    { to: "/support", label: "Support", icon: supportIcon, match: "/support" },
    { to: "/transfers", label: "Transfers", icon: TransfersIcon, match: "/transfers" },
    { to: "/issues-resolutions", label: "Issues & Resolutions", icon: infoShieldIcon, match: "/issues-resolutions" },
    { to: "/reports", label: "Reports", icon: reportIcon, match: "/report" },
    { to: "/pushNotifications", label: "Push", icon: bellIcon, match: "/push" },
    { to: "/discounts", label: "Discounts", icon: discountIcon, match: "/discount" },
    { to: "/referrals", label: "Referrals", icon: ticketIcon, match: "/referral" },
  ];

  return (
    <>
      <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-top">
        {userDetails.jwttoken != null &&
          userDetails.accountInfo.username != null ? (
          <>
            <ul>
              {navItems.map(({ to, label, icon, match, exact }) => (
                <NavItem
                  key={to}
                  to={to}
                  label={label}
                  icon={icon}
                  match={match}
                  exact={exact}
                  isCollapsed={isCollapsed}
                />
              ))}
              <li></li>
            </ul>

            <div
              ref={logoutRef}
              onMouseEnter={() => isCollapsed && setShowLogoutTooltip(true)}
              onMouseLeave={() => setShowLogoutTooltip(false)}
            >
              <NavLink
                className={({ isActive }) =>
                  isActive || pathname.startsWith("/logout")
                    ? "sidebar-link active"
                    : "sidebar-link"
                }
                activeclassname="active"
                to="/logout"
              >
                <img
                  className={pathname.startsWith("/logout") ? "img_invert" : ""}
                  src={arrowRightSquareIcon}
                  alt="Log Out"
                />
                {!isCollapsed && <span>Log Out</span>}
              </NavLink>
              <Tooltip label="Log Out" targetRef={logoutRef} visible={showLogoutTooltip} />
            </div>
          </>
        ) : (
          <ul>
            <li>
              <NavLink
                className={({ isActive }) =>
                  isActive || pathname.startsWith("/signin")
                    ? "sidebar-link active"
                    : "sidebar-link"
                }
                to="/signin"
              >
                <img
                  className={pathname.startsWith("/signin") ? "img_invert" : ""}
                  src={lockIcon}
                  alt="Sign In"
                />
                {!isCollapsed && "Sign In"}
              </NavLink>
            </li>
          </ul>
        )}
      </div>
    </aside>
      <button
        className="sidebar-toggle"
        onClick={() => setIsCollapsed(!isCollapsed)}
        style={{ left: isCollapsed ? "66px" : "242px" }}
        title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
          <path
            d={isCollapsed ? "M8 5L13 10L8 15" : "M12 5L7 10L12 15"}
            stroke="#ffffff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </>
  );
};

export default Navigation;
